import { get } from 'lodash/object'
import { find, map, filter } from 'lodash/collection'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  owner: null
})

export const getters = {
  items: state => state.items,
  owner: state => state.owner
}

export const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_OWNER(state, owner) {
    state.owner = owner
  },
  ADD_ITEM(state, item) {
    const isUpdate = find(state.items, participant => participant.id === item.id)
    if (isUpdate) {
      state.items = map(state.items, participant =>
        participant.id === item.id ? item : participant
      )
    } else {
      state.items.push(item)
    }
  },
  REMOVE_ITEM(state, itemId) {
    state.items = filter(state.items, item => item.id !== itemId)
  },
  RESET(state) {
    state.items = []
    state.owner = null
  }
}

export const actions = {
  async getAllDocumentParticipants({ commit }, { documentId, config = {} }) {
    const participants = get(
      await this.$axios.get(routes.document.participants(documentId), config),
      'data'
    )
    commit('SET_ITEMS', participants)

    return participants
  },
  // Method returns object with owner and children of participants
  async getAllDocumentParticipantsWithOwner({ commit }, { documentId, config = {} }) {
    const participantsData = get(
      await this.$axios.get(routes.document.participantsV2(documentId), config),
      'data'
    )
    if (participantsData) {
      commit('SET_ITEMS', get(participantsData, 'children', []))
      const ownerData = structuredClone(participantsData)
      if ('children' in ownerData) delete ownerData.children
      commit('SET_OWNER', ownerData)
    }

    return participantsData
  },
  async update({ commit }, { id, payload, config = {} }) {
    const updatedParticipant = get(
      await this.$axios.put(routes.participant.concrete(id), payload, config),
      'data'
    )
    commit('ADD_ITEM', updatedParticipant)
    return updatedParticipant
  },
  async delete({ commit }, { id, config = {} }) {
    await this.$axios.delete(routes.participant.concrete(id), config)
    commit('REMOVE_ITEM', id)
  },
  async createDocumentParticipant(
    { commit },
    { documentId, payload, validate = false, saveItems = true, config = {} }
  ) {
    const params = {}
    if (validate) {
      params.validate = true
    }
    const participant = get(
      await this.$axios.post(routes.document.participants(documentId), payload, {
        params,
        ...config
      }),
      'data'
    )
    if (!validate && saveItems) {
      commit('ADD_ITEM', participant)
    }
    return participant
  }
}
